module.exports = __webpack_public_path__ + "media/images/athletes/506-cfc5315fa0607e5a38ccea7f25ad7073.png";